import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useI18n } from '../context/i18nContext';
import '../styles/AuthPages.css';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const { t } = useI18n();

  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); return; }

    fetch(`/api/auth/verify-email?token=${token}`)
      .then(r => r.json())
      .then(data => setStatus(data.message ? 'success' : 'error'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <div className="auth-page-container">
      <div className="auth-card">
        <div className="auth-logo">✉️</div>
        <h1 className="auth-title">{t('email.verifyTitle')}</h1>

        {status === 'loading' && (
          <p className="auth-message loading">{t('email.verifyLoading')}</p>
        )}
        {status === 'success' && (
          <>
            <p className="auth-message success">✅ {t('email.verifySuccess')}</p>
            <Link to="/login" className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
              {t('auth.button.login')}
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="auth-message error">❌ {t('email.verifyFailed')}</p>
            <Link to="/dashboard" className="btn-secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>
              {t('common.dashboard')}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
